@for (node of timeline; track $index) {
<div class="flex flex-row gap-2">
  <div class="flex flex-col gap-1 items-center w-8">
    @switch (node.state) {
    <!-- Case COMPLETED -->
    @case (TimelineNodeState.COMPLETED) {
    <div
      class="flex flex-col items-center justify-center bg-blue-150 rounded-full w-4 h-4"
    >
      <svg-icon src="assets/icons/check.svg" svgClass="h-3 w-3 text-light-0" />
    </div>

    <div class="grow w-full relative overflow-hidden">
      <svg-icon
        *ngIf="!$last"
        src="assets/icons/line.svg"
        svgClass="text-blue-150 absolute inset-0 m-auto"
      />
    </div>

    }
    <!-- Case ACTIVE -->
    @case (TimelineNodeState.ACTIVE) {
    <div
      class="flex flex-col items-center justify-center bg-light-0 rounded-full w-5 h-5 border-[2px] border-blue-150"
    >
      <div class="bg-blue-150 rounded-full w-2 h-2"></div>
    </div>

    <div class="grow w-full relative overflow-hidden">
      <svg-icon
        *ngIf="!$last"
        src="assets/icons/stroke-line.svg"
        svgClass="text-blue-150 absolute inset-0 m-auto"
      />
    </div>
    }
    <!-- Case INCOMPLETED -->
    @case (TimelineNodeState.INCOMPLETED) {
    <div
      class="flex flex-col items-center justify-center bg-light-180 rounded-full w-4 h-4"
    >
      <div class="bg-light-170 rounded-full w-[9px] h-[9px]"></div>
    </div>

    <div class="grow w-full relative overflow-hidden">
      <svg-icon
        *ngIf="!$last"
        src="assets/icons/line.svg"
        svgClass="text-light-180 absolute inset-0 m-auto"
      />
    </div>
    }
    <!--  -->
    }

    <div></div>
  </div>

  <div class="flex flex-col gap-2 -mt-1 grow" [ngClass]="{ 'pb-8': !$last }">
    <div class="flex flex-row gap-2 items-center justify-between">
      <h1 class="font-bold text-base text-light-300">
        {{ node.header }}
      </h1>

      @if (node.headerExtra) {
      <div class="flex flex-row gap-2 text-light-170">
        <svg-icon [src]="node.headerExtraImg" svgClass="h-4 w-4" />
        <p class="text-xs">{{ node.headerExtra }}</p>
      </div>
      }
    </div>

    @if (node.date) {
    <p class="font-medium text-sm text-light-100">
      {{ node.date | date : "MMMM d, y" }}
    </p>
    }

    <!--  -->
    @if (node.highlightedInfoIcon && node.highlightedInfoLabel) {
    <div class="flex gap-1 items-center bg-blue-160 py-1 px-2 rounded-lg w-fit">
      <svg-icon [src]="node.highlightedInfoIcon" svgClass="w-5 h-5" />
      <p class="font-bold text-xs text-blue-400">
        {{ node.highlightedInfoLabel }}
      </p>
    </div>
    }

    <!--  -->

    @for (item of node.description; track $index) {
    <p
      class="text-sm"
      [ngClass]="
        node.description.length > 1 ? 'text-light-100' : 'text-light-300'
      "
    >
      {{ item }}
    </p>
    }
  </div>
</div>
}
